export default "__VITE_ASSET__b1e03664__"